import { gql } from '@apollo/client';

export default gql`
  query emailSuppressions(
    $limit: Int
    $q: String
    $statuses: [String!]
    $triageStatuses: [String!]
  ) {
    emailSuppressions(
      limit: $limit
      q: $q
      statuses: $statuses
      triageStatuses: $triageStatuses
    ) {
      id
      email
      normalizedEmail
      status
      triageStatus
      reason
      source
      eventCount
      firstEventAt
      lastEventAt
      lastDiagnosticCode
      lastSesMessageId
      lastFeedbackId
      matchingRecipients {
        id
        email
        name
        recordType
      }
    }
  }
`;
